function getAuthTypesFromBroadcasts(broadcasts = []) {
    const authTypes = [];
    if (broadcasts.length > 0) {
        authTypes.push('mvpd');
        if (broadcasts[0].ipAuth === true) {
            authTypes.push('isp');
        }
    }
    return authTypes;
}

/**
 * Takes a listing from the v1 api and converts it to a content item
 */
module.exports = (listing = {}) => {
    return {
        id: listing.id,
        type: 'event',
        status: listing.type,
        authTypes: getAuthTypesFromBroadcasts(listing.broadcasts)
    };
};



// WEBPACK FOOTER //
// ./app/lib/format/getContentFromListing.js